import React from 'react';

const Spinner = () => {
  return <div id="spinner" className="actions"></div>;
};

export { Spinner };
